<template>
  <div class="homepage_wrap">
    <div class="homepage_head">
      <img :src="this.brand_info.air_newhomepage_bg" alt="">
    </div>
    <div class="w1200" style="width: 900px">
      <div class="paomadeng" v-if="top_msg" v-show="top_msg" @click="toMsgShow(top_msg)">
        <div class="left">
          <img src="../../assets/index_v2/tz-icon-v2.png" alt="">
          通知
        </div>
        <div class="right">
          <marquee direction="left" loop="loop">{{top_msg.title}}</marquee>
        </div>
      </div>
    </div>
    <div class="homepage_body" v-show="this.userInfo">
      <div class="homepage-row">
        <div class="item">
          <div class="card" @click="to_learning('dancisuji')">
            <div class="card-head">单词速记</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/danci.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('fenjiyuedu')">
            <div class="card-head">分级阅读</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/yuedu.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('gaoxiaoyufa')">
            <div class="card-head">高效语法</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/yufa.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('qingsongxiezuo')">
            <div class="card-head">轻松写作</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/xiezuo.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('shipinkecheng')">
            <div class="card-head">视频课程</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/shipin.png">
            </div>
          </div>
        </div>
      </div>
      <div class="homepage-row">
        <div class="item">
          <div class="card" @click="to_learning('danci_pk')">
            <div class="card-head">单词PK</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/PK.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('danci_gendu')">
            <div class="card-head">单词领读</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/gendu.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="card" @click="to_learning('mingzhuyuedu')">
            <div class="card-head">名著阅读</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/mingzhu_yue_du.png">
            </div>
          </div>
        </div>

        <div class="item">
          <div class="card" @click="to_learning('dancijingsai')">
            <div class="card-head">单词竞赛</div>
            <div class="card-body">
              <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/2023_0605_cepin.png">
            </div>
          </div>
        </div>



        <div class="item">
          <div class="card" @click="to_learning('cihuiliang_ceping')">
            <div class="card-head">词汇量测评</div>
            <div class="card-body">
              <img src="../../../src/assets/new_index/cepin.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="word_pk_layer" v-if="show_word_pk">
      <div class="layer_content">
        <div class="word_pk_hd">
          <div @click="word_pk_page_toggle('jinxingzhong')" class="item" :class="[(word_pk_page=='jinxingzhong')?'active':'']">进行中</div>
          <div @click="word_pk_page_toggle('quanbu')" class="item" :class="[(word_pk_page=='quanbu')?'active':'']">全部</div>
        </div>
        <div class="word_pk_bd">
          <div v-if="word_pk_page==='jinxingzhong'">进行中</div>
          <div v-if="word_pk_page==='quanbu'">全部</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.word_pk_layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  .layer_content {
    height: 500px;
    width: 700px;
    background-color: #fff;
    border-radius: 10px;
    .word_pk_hd{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-around;
      align-items: center;
      .item{
        color:rgba(6, 58, 26, 1);
        background-color: rgba(226,245,238,1);
        width: 100%;
        text-align: center;
        padding: 2rem;
        font-weight: bolder;
        font-size: 19px;
        &.active{
          color:#fff;
          background-color:rgba(39, 191, 149, 1);
        }
      }
    }
  }
}
.paomadeng{
  display: flex;
  margin-top: 1rem;
  background-color:rgba(236,247,255,1);
  font-weight:bold;
  .left{
    width: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding:0 10px;
    img{
      margin-right: 3px;
      width: 20px;
    }
  }
  .right{
    height: 35px;
    line-height: 35px;
    flex:1;
    box-sizing: border-box;
    padding:0 5px;
    white-space: nowrap;
  }
  svg{
    fill:#fff;
    width: 15px;
    height: 15px;
  }
}

.homepage_wrap {
  .homepage_head {
    min-width: 1200px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .homepage-row {
    width: 900px;
    margin: 2rem auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;

    .item {
      width: 160px;
      height: 190px;
      margin: 0 1rem;
      background: #ffffff;
      box-shadow: 0 5px 8px 0 rgba(173, 173, 173, 0.5);
    }
  }
}

.card {
  .card-head {
    text-align: center;
    color: rgba(38, 76, 42, 1);
    font-weight: bolder;
    font-size: 20px;
    padding-top: 2rem;
  }

  .card-body {
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    flex-direction: row;
    justify-content: center;

    img {
      width: 80%;
    }
  }
}

</style>
<script>
import { fetchHomeCarousel,getTopMsg } from '@/services/index'
import store from '@/store'
import mTypes from '@/store/mutationsTypes'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      top_msg:null,
      carouselList: [],
      show_word_pk:false,
      word_pk_list:null,
      word_pk_page:'jinxingzhong',
      air_newhomepage_bg:'',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      brand_info: state => state.brand_info,
    })
  },
  watch: {},
  methods: {
    toMsgShow(item){
      console.log('click msg:',item)
      if(item.type===2){
        this.$router.push({
          path: '/msg',
          query: {
            id:item.id,
          }
        })
      }
      if(item.type===3){
        this.openwindow(item.url,'',700,650);
      }
    },
    to_learning (code) {
      if(!this.brand_info){
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.reload();
        this.$message.error('请登录')
        return;
      }
      if(!this.userInfo['id']){
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.reload();
        this.$message.error('未登录')
        return;
      }

      if(code==='dancijingsai'){
        this.$router.push({
          path:'/word_competition',
        });
      }

      if (code === 'dancisuji') {
        if(this.brand_info.course_modules.word && this.brand_info.course_modules.word===1){
            window.location.href = `${process.env.VUE_APP_PADURL}#/wordRemember?ref=homepage`
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'fenjiyuedu') {
        if(this.brand_info.course_modules.reading && this.brand_info.course_modules.reading===1){
          window.location.href = `${process.env.VUE_APP_PADURL}#/super-read?ref=homepage`
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'gaoxiaoyufa') {
        if(this.brand_info.course_modules.grammar && this.brand_info.course_modules.grammar===1){
          window.location.href = `${process.env.VUE_APP_PADURL}#/reverse?ref=homepage`
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'qingsongxiezuo') {
        if(this.brand_info.course_modules.composition && this.brand_info.course_modules.composition===1){
          window.location.href = `${process.env.VUE_APP_PADURL}#/composition?ref=homepage`
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'shipinkecheng') {
        if(this.brand_info.course_modules.video && this.brand_info.course_modules.video===1){
          if(this.brand_info.video_course_access_url){
            this.$router.push('/course_video')
          }
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'danci_pk') {
        if(this.brand_info.course_modules.word && this.brand_info.course_modules.word===1){

          if(this.userInfo.is_open_word_pk){
            window.location.href = `${process.env.VUE_APP_PADURL}#/wordRemember?ref=homepage`
          }else{
            this.$message.error('仅限老师使用')
          }


        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'danci_gendu') {
        if(this.brand_info.course_modules.word && this.brand_info.course_modules.word===1){
          window.location.href = `${process.env.VUE_APP_PADURL}#/wordRemember?ref=homepage`
        }else{
          this.$message.error('未开通')
        }
      }
      if (code === 'cihuiliang_ceping') {
        this.$router.push('/word_test')
      }
      if(code==='mingzhuyuedu'){
        if((this.brand_info &&this.brand_info.is_show_famous_read) || (this.userInfo&&this.userInfo.is_show_famous_read)){
          this.$router.push('/famous_read')
        }else{
          this.$message.error('未开通')
        }
      }
    },
    word_pk_page_toggle(page){
      this.word_pk_page=page;
      let render_word_pk_list=function () {
          return [];
      };
      if(this.word_pk_page==='jinxingzhong'){
        render_word_pk_list()
      }
      if(this.word_pk_page==='quanbu'){
        render_word_pk_list()
      }
    },
  },
  created () {
    if (!store.state.carousel_list.length) {
      fetchHomeCarousel().then(res => {
        if (res.code === 1) {
          this.carouselList = res.data
          store.commit(mTypes.carousel_list, res.data)
        }
      })
    } else {
      this.carouselList = store.state.carousel_list
    }

    // if(this.userInfo && this.userInfo.id){
    //   getTopMsg().then((res)=>{
    //     if(res.data && res.data[0]){
    //       this.top_msg=res.data[0];
    //     }
    //   });
    // }


  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  activated () {
  }
}
</script>